import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { CuestionariosService } from '../services/cuestionarios.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-script-dialog',
  templateUrl: './script-dialog.component.html',
  providers: [MessageService]
})
export class ScriptDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() preguntaSeleccionada: any = null;
  @Input() cuestionario: any = null;
  @Input() opcionSeleccionada: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean}>();
  @ViewChild('dt') table!: Table;

  loading: boolean = false;
  scripts: any[] = [];
  displayedColumns = [
    { field: 'iNumScript', header: 'N° Script' },
    { field: 'sComentario', header: 'Comentario' },
    { field: 'actions', header: 'Acciones' }
  ];

  displayNuevoScriptDialog: boolean = false;
  scriptSeleccionado: any = null;

  constructor(
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService
  ) {}

  ngOnInit(): void {
    // No cargamos aquí, esperamos a que se abra el diálogo
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('ScriptDialog - Cambios detectados:', changes);
    if (changes['displayDialog']?.currentValue === true) {
      this.cargarScripts();
    }
  }

  cargarScripts(): void {
    if (!this.cuestionario?.sClaveCues || !this.preguntaSeleccionada?.iNumPreg || !this.opcionSeleccionada?.iNumOpcion) {
      console.error('ScriptDialog - Faltan datos necesarios para cargar scripts:', {
        sClaveCues: this.cuestionario?.sClaveCues,
        iNumPreg: this.preguntaSeleccionada?.iNumPreg,
        iNumOpcion: this.opcionSeleccionada?.iNumOpcion
      });
      return;
    }

    this.loading = true;
    const request = {
      que: 4,
      tope: "999",
      sClaveCues: this.cuestionario.sClaveCues,
      iNumPreg: this.preguntaSeleccionada.iNumPreg,
      iNumOpcion: this.opcionSeleccionada.iNumOpcion,
      iNumScript: 0,
      sComentario: ""
    };

    console.log('ScriptDialog - Enviando request para cargar scripts:', request);

    this.cuestionariosService.getScripts(request).subscribe({
      next: (response) => {
        console.log('ScriptDialog - Respuesta del servicio:', response);
        if (response.success) {
          this.scripts = response.data;
          console.log('ScriptDialog - Scripts cargados:', this.scripts);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los scripts'
          });
        }
      },
      error: (error) => {
        console.error('ScriptDialog - Error al cargar scripts:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar los scripts'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openNew(): void {
    this.scriptSeleccionado = null;
    this.displayNuevoScriptDialog = true;
  }

  editScript(script: any): void {
    console.log('Editando script:', script);
    this.scriptSeleccionado = { ...script };
    this.displayNuevoScriptDialog = true;
  }

  deleteScript(script: any): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Deseas eliminar el script ${script.iNumScript}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const request = {
          que: 3,
          tope: "",
          sClaveCues: this.cuestionario.sClaveCues,
          iNumPreg: this.preguntaSeleccionada.iNumPreg,
          iNumOpcion: this.opcionSeleccionada.iNumOpcion,
          iNumScript: script.iNumScript,
          sComentario: ""
        };

        this.cuestionariosService.guardarScript(request).subscribe({
          next: (response) => {
            if (response.success && response.data.error === "0") {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Script eliminado correctamente'
              });
              this.cargarScripts();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar el script'
              });
            }
          },
          error: (error) => {
            console.error('Error al eliminar script:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Ocurrió un error al eliminar el script'
            });
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }

  onNuevoScriptDialogClosed(event: {refresh: boolean}): void {
    this.displayNuevoScriptDialog = false;
    this.scriptSeleccionado = null;
    if (event.refresh) {
      this.cargarScripts();
    }
  }
} 